import React, { createContext, useEffect, useState } from 'react';
export const PermissionsContext = createContext({
    shouldReload: false,
    setShouldReload: () => {
        return;
    },
});
export const PermissionsProvider = (props) => {
    const { children } = props;
    const [shouldReload, setShouldReload] = useState(false);
    useEffect(() => {
        if (shouldReload)
            setShouldReload(false);
    }, [shouldReload]);
    return (React.createElement(PermissionsContext.Provider, { value: { shouldReload, setShouldReload } }, children));
};
//# sourceMappingURL=PermissionsProvider.js.map